export enum DateRangeMode {
  MONTH = 'MONTH',
  DAY = 'DAY',
  YEAR = 'YEAR',
  ALL = 'ALL',
}
